import { ChartDataColumn } from './chart-data-column';
export class ChartColumnClick {
  constructor(
    public columnIndex: number,
    public dataIndex: number,
    public column: ChartDataColumn,
    public data: number
    ) {}
}
